import style from "./CardsModal.module.css";

function ZoomImage(props) {

    return (
        <div className={style.clickZoom}>
            <label>
                <input type="checkbox"></input>
                {props.image}
            </label>
        </div>
    )
}

export default ZoomImage